import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { VinculosAPI } from '../../../../shared/http-requests';
import { connect } from 'react-redux';
import { buildSecureUrl, validateAndSanitizeCodAcervo, secureReplace } from '../../../../shared/security/urlSecurity';

const RestrictCollection = ({userSessionRx,userLocalRx}) => {
    const { codAcervo } = useParams();
    const navigate = useNavigate()
    const [loading, setLoading] = useState(true);
    const isAuthenticated = userSessionRx || userLocalRx;

    useEffect(() => {
        const validatedCodAcervo = validateAndSanitizeCodAcervo(codAcervo);

        if(validatedCodAcervo){

            VinculosAPI.buscarLinksAcervos(validatedCodAcervo).then((response) => {
                const { data } = response;
                if(data && data?.length > 0) {
                    const { links } = data[0];
                    const restricted = links.filter(link => ['acesso restrito', 'acesso restrito - visualizar'].includes(link?.descricao?.trim()?.toLowerCase()))
                    if(restricted.length > 0 ){
                        if(isAuthenticated){
                            navigate(`/acesso-restrito/${validatedCodAcervo}`, { replace: true });
                            return;
                        }
                        setLoading(false)
                        const redirectUrl = buildSecureUrl(`/acesso-restrito/${validatedCodAcervo}`, validatedCodAcervo);
                        navigate(`/login?redirect=${encodeURIComponent(redirectUrl)}&destination=C&origin=restricted_access`, { replace: true });
                    }else{
                        navigate(`/acervo/${validatedCodAcervo}`, { replace: true });
                    }
                }
            }).catch(() => {
                setLoading(false)
                navigate(`/`, { replace: true })
            })
        } else {
            // Se o código do acervo não for válido, redireciona para a página inicial
            setLoading(false)
            navigate(`/`, { replace: true })
        }
    }, [codAcervo, isAuthenticated]);


    return (
        <div>
            {loading ? 'Carregando ...'  : ''}
        </div>
    )
}


const mapStateToProps = state => ({
    userSessionRx: state.auth.user,
    userLocalRx: state.authPersist.user,
});


export default connect(mapStateToProps)(RestrictCollection);
